// extracted by mini-css-extract-plugin
export default {"container":"tIzLKAG3_vXfTYp8JBIR","mobileLayout":"rXRGKaUZrsMUfXTRqJQj"};